// extracted by mini-css-extract-plugin
export default {"container":"CurrentLineDetail_container__w0GkP","wrapper":"CurrentLineDetail_wrapper__YJEAx"};